import * as t from "io-ts";
import nullable from "./nullable";
export const ssoIntegrationT = t.strict({
    integration: nullable(t.literal("Microsoft")),
    allowedGroupIds: t.array(t.string),
});
export const microsoftGroupT = t.strict({
    id: t.string,
    name: t.string,
});
export const saveMicrosoftGroupAllowlistT = t.strict({
    groupIds: t.array(t.string),
});
export const tenantGroupsT = t.strict({
    groups: t.array(microsoftGroupT),
});
//# sourceMappingURL=sso.js.map